module.exports = __webpack_public_path__ + "static/img/106.881e48b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/106.png
// module id = ftGR
// module chunks = 0